import React, { useState } from 'react'
import ForgotPasswordFormPage from './form'
import ForgotPasswordEndPage from './end'

const ForgotPassword = () => {
  const [showEnd, setShowEnd] = useState(false)
  return (
    <>
      {!showEnd
        ? <ForgotPasswordFormPage onFinalize={() => setShowEnd(true)} />
        : <ForgotPasswordEndPage />}
    </>
  )
}
export default ForgotPassword
